"use client";

import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
export default function ReadyForATestDrive() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222452" id="begin-your-journey" className="bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-primary/5 z-10" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent z-10" />
        <div className="absolute inset-0 bg-none opacity-10 scale-105" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 py-32 md:py-48 lg:py-56 flex flex-col items-center justify-center text-center">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight text-primary mb-10">Want to Know More?</h2>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 w-full max-w-lg mx-auto">
            <Button asChild size="lg" className="w-full sm:w-auto text-lg h-14 px-10 rounded-full bg-accent text-accent-foreground shadow-lg hover:bg-accent/90 hover:scale-105 transition-all duration-300">
              
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-lg h-14 px-10 rounded-full bg-transparent border-primary text-primary hover:bg-primary/5 hover:text-primary backdrop-blur-sm transition-all duration-300">
              <Link to="#">Contact Us</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}